module.exports = __webpack_public_path__ + "static/img/brees-2012-slide-5.b19fa85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-slide-5.jpg
// module id = It96
// module chunks = 1